var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('overlay',{on:{"click":_vm.hide},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('div',{class:_vm.elementClass},[_c('scrollbar',[_vm._t("default")],2)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }